<router-outlet></router-outlet>
<app-svg-admin></app-svg-admin>

<mat-progress-bar *ngIf="showLoader" mode="indeterminate"> </mat-progress-bar>
